import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './Styles/style.css';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en.json';
import translationDE from './locales/de.json';
import ObjectView from './ObjectsView';
import Login from './Login';

const isFirstStartup = localStorage.getItem('isFirstStartup');

if (!isFirstStartup) 
{
    localStorage.clear();
    localStorage.setItem('isFirstStartup', 'true');
}

const checkLoggedIn = localStorage.getItem('successLogin');

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en: { translation: translationEN },
            de: { translation: translationDE }
        },
        fallbackLng: "de",
        interpolation: {
            escapeValue: false
        }
    });

const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement).render(
    checkLoggedIn !== 'true' ? <Login /> : <ObjectView />
);